let Flickity = require('flickity');

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
    }

    init() {
        let self = this;

        self.gallery();
    }

    gallery() {
        let self = this;

        new Flickity(self.carousel, {
            pageDots: false,
            cellAlign: 'left',
            wrapAround: true,
            autoPlay: 5000,
            prevNextButtons: false
        });
    }
}

export default Carousel;